import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  ranking = 1,
  tasks,
  sales,
}

export enum RankTabEnum {
  // 榜单子tab
  list = 1,
  rule,
}
export enum RewardTypeEnum {
  // 类型 1 为cp任务奖励 2 为个人任务奖励
  cp = 1,
  own,
}
// 情人节任务 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31614493
export const valentine_day_misson = createAsyncThunk(
  'valentine_day_misson',
  async (arg: {type: RewardTypeEnum}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'list'
          | 'avatar1'
          | 'avatar2'
          | 'mid1'
          | 'mid2'
          | 'is_receive'
          | 'target'
          | 'score'
          | 'count_down'
        >
      >
    >(
      '/live/activity/valentine_day_misson',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 情人节任务 tab切换 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31614493
export const valentine_day_tab = createAsyncThunk(
  'valentine_day_tab',
  async (arg: {type: RewardTypeEnum}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<InitialStateType, 'is_receive' | 'score' | 'target' | 'list'>
      >
    >('/live/activity/valentine_day_misson', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
export const emptyRankInfo = {
  rank: -1,
  name1: '',
  name2: '',
  mid1: 0,
  mid2: 0,
  avatar1: '',
  avatar2: '',
  score: 0,
}

// 情人节盲盒 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=25136246
export const valentine_blind_box = createAsyncThunk(
  'valentine_blind_box',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'blind_box_id' | 'blind_box_cost' | 'blind_boxes'
        >
      >
    >('/live/gift/blind_box', {
      ...store.getState().env.deviceinfo,
      type: 3,
    })
    return resp.data.data
  }
)
// 情人节排行榜 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31614197
export const valentine_day_rank = createAsyncThunk(
  'valentine_day_rank',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'cp_mid'
          | 'cp_name'
          | 'cp_avatar'
          | 'name'
          | 'avatar'
          | 'list'
          | 'score'
        >
      >
    >(
      '/live/activity/valentine_day_rank',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 情人节领取奖励 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31615523
export const valentine_day_receive = createAsyncThunk(
  'valentine_day_receive',
  async (arg: {type: RewardTypeEnum}, store: any) => {
    const resp = await http.post<HiyaRes<{status: 1 | 2 | 3; err_msg: string}>>(
      '/live/activity/valentine_day_receive',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

interface ValentineLightUpInfo {
  gift_id: number
  gift_name: string
  gift_url: string
  is_light: boolean
  coins: number
}
interface RankInfo {
  rank: number
  name1: string
  name2: string
  mid1: number
  mid2: number
  avatar1: string
  avatar2: string
  score: number
}
interface BlindBoxesItemType {
  // 礼物ID
  gift_id: number
  // 礼物名称
  gift_name: string
  // 礼物链接
  gift_url: string
  // 礼物价值
  gift_cost: number
}
interface InitialStateType {
  // 任务列表	图标情况
  list?: Array<ValentineLightUpInfo>
  rank?: number
  // icon点亮的数目
  lights?: number
  // 任务信息相关的参数
  avatar1?: string
  avatar2?: string
  mid1?: number
  mid2?: number
  is_receive?: boolean
  target?: number
  score?: number
  count_down?: number
  // cp榜单的数据
  cpList?: Array<RankInfo>
  ownScore?: number
  cp_mid?: number
  cp_name?: number
  cp_avatar?: string
  name?: string
  avatar?: string
  // 盲盒
  blind_box_id?: number
  blind_box_cost?: number
  blind_boxes?: Array<BlindBoxesItemType>
}

const initialState: InitialStateType = {}

export const Valentine2022Slice = createSlice({
  name: 'Valentine2022',
  initialState,
  reducers: {
    changeGiftStatucs: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        is_receive: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(valentine_day_misson.fulfilled, (state, action) => {
      const {list} = action.payload
      const lights = list ? list.filter((v) => v.is_light === true).length : 0
      Object.assign(state, action.payload, {lights})
    })
    builder.addCase(valentine_day_tab.fulfilled, (state, action) => {
      const {is_receive, score, target} = action.payload
      // const lights = list ? list.filter((v) => v.is_light === true).length : 0
      Object.assign(state, {is_receive, score, target})
    })
    builder.addCase(valentine_day_rank.fulfilled, (state, action) => {
      const {list, score, ...rest} = action.payload
      const ret = {
        cpList: list || [],
        ownScore: score || 0,
      }
      Object.assign(state, rest, ret)
    })
    builder.addCase(valentine_blind_box.fulfilled, (state, action) => {
      const {blind_box_id, blind_box_cost, blind_boxes} = action.payload
      Object.assign(state, {blind_box_id, blind_box_cost, blind_boxes})
    })
  },
})
export default Valentine2022Slice.reducer
export const Valentine2022Actions = Valentine2022Slice.actions
